import { CommonModule } from '@angular/common';
import { AfterViewInit, TemplateRef, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import moment from 'moment';
import { MaterialModule } from '../../material.module';
import { SubmissionsapiService } from '../charity/submissions/submissionsapi.service';
import * as vkbeautify from 'vkbeautify';
import { AceModule } from 'ngx-ace-wrapper';
import jsPDF from 'jspdf';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/theme-eclipse';
import 'ace-builds/src-noconflict/ext-language_tools';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { LocalStorage } from '@ng-idle/core';
import { AutoupperCaseDirective } from '../../Directives/autoupper-case.directive';
import { UsermanagementService } from '../../services/apps/usermanagement/usermanagement.service';
import { RolesModel } from '../../Data/Models/Users/roles-model';



@Component({
  selector: 'app-submission-history',
  imports: [AceModule, TablerIconsModule, MaterialModule, FormsModule, CommonModule, ReactiveFormsModule, MatPaginatorModule, MatSortModule, MatTableModule, MatInputModule, PdfJsViewerModule, AutoupperCaseDirective],
  templateUrl: './submission-history.component.html',
 
  styleUrl: './submission-history.component.scss'
})

export class SubmissionHistoryComponent implements OnInit, AfterViewInit {

  submissionHistoryGrid: boolean = true;
  submissionStatus: boolean = false;
  dataSource= new MatTableDataSource<any>();
  charitydataSource= new MatTableDataSource<any>();
  loading = true;
  CharityFilterForm!: FormGroup;
  charitySubmissions: any
  xmlview:boolean=false
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatPaginator) paginator2!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatSort) sort2!: MatSort;
  @ViewChild('xmlViewerTemplate') xmlViewerTemplate!: TemplateRef<any>;
  filterblock: boolean = false;
    currentUser: any;
    submissionshistory: any=[];
    charitySummary: { charityId: string; charityName: string; totalSubmissions: number; }[];
    charities: any;
    xmlData: any;
    xmlDataRequest: string;
    charityName: any;
    pdfFile: string;
    loadspinner: boolean;
    charitySubmissionsfromapi: { submissionId: any; date: any; accountingPeriod: string; charityName: any; charityId: any; submissionType: string; reference: any; transactionNumber: any; status: any; }[];
    submissionId: any;

  constructor(public dialog: MatDialog, private router: Router, private fb: FormBuilder, public Submissionsapiservice: SubmissionsapiService, private _UsermanagementService: UsermanagementService) {
    this.GetUserAccess();

  }

  mode = 'text';
  theme = 'eclipse';
  editorOptions = {
    fontSize: '14px',
    showPrintMargin: false,
    readOnly: true,        // for viewing only
    showFoldWidgets: false, // enable folding
    foldStyle: 'markbegin',
  };

  onCodeChange(newValue: string) {
    console.log('Updated XML:', newValue);
  }

  ngOnInit(): void {
    this.CreateForm()
    this.getCharities()
    this.getsubmissionhistory();
  }

  ngAfterViewInit() {
    debugger
    setTimeout(() => {
      debugger
      const el = document.querySelector('.active');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
    });
  }
  uniqueStatusSet: any
  getsubmissionhistory() {
    debugger
    this.loadspinner=true
    var UserId = localStorage.getItem('userID')
    
    this.Submissionsapiservice.getSubmissionhistory(UserId).subscribe({
      next: (data: any[]) => {
        debugger
        if (data != null) {
          const submissions = data.map((item: any) => ({
            date: item.fbiStartTimeStamp,
            AccountingPeriod: `${this.formatDate(item.current_AP_Start_Date)} - ${this.formatDate(item.current_AP_End_Date)}`,
            CharityName: item.charityName,
            CharityId: item.charityId,
            SubmissionType: item.account_Type,
            Reference: item.submissionNumber,
            TransactionNumber: item.transactionID || 'N/A',
            Status: item.companyHouseSubmissionStatus || 'Pending'
          }));

          this.dataSource = new MatTableDataSource(submissions);

          this.dataSource.filterPredicate = (data: any, filter: string): boolean => {
            const formattedFilter = filter.trim().toLowerCase();

            return Object.values(data).some((value: any) => {
              if (value == null) return false;
              return value.toString().toLowerCase().startsWith(formattedFilter);
            });
          };

          // Attach paginator and sort after data binding
          setTimeout(() => {
            if (this.paginator && this.dataSource) {
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;


              this.paginator.pageSize = 10;

              this.paginator.length = this.dataSource.data.length;


              this.paginator._changePageSize(this.paginator.pageSize);
            }
          });
        

          this.loadspinner = false;
        }
        else { this.loadspinner = false;}
      },
      error: (err) => {
        console.error('Error fetching submission history:', err);
        this.loadspinner = false;
      }
    });
  }
  getCharities() {
    var UserId = localStorage.getItem('userID')
    this.Submissionsapiservice.getcharities(UserId).subscribe((data: any) => {
      if (data) {
        debugger
        this.charities = data
      }
      })
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); 
  }

  applyFilter(event: Event) {
    debugger

    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.filteredData?.length > 0 && filterValue )  {
      this.paginator.length = this.dataSource.filteredData?.length;
    }
    else {
      if (this.paginator) {
        this.paginator.length = this.dataSource.data?.length;
      }
    }
  }
  applyCharitySearch(event: Event) {
    debugger
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.charitydataSource.filter = filterValue;
    if (this.charitydataSource.filteredData?.length > 0 && filterValue) {
      this.paginator2.length = this.charitydataSource.filteredData?.length;
    }
    else {
      if (this.paginator2) {
        this.paginator2.length = this.charitydataSource.data?.length;
      }
    }
  }

  filter() {
    this.filterblock = !this.filterblock
  }
  closeFilter() {
    this.filterblock = !this.filterblock
    this.clearCharityfilter()
  }
  matchDate(subDateStr: string, dateFilter?: 'today' | 'thisWeek' | 'thisMonth'): boolean {
  if (!dateFilter) return true; // no filter, always true

  const subDate = moment(subDateStr, 'YYYY-MM-DD HH:mm:ss');

  switch (dateFilter) {
    case 'today':
      return subDate.isSame(moment(), 'day');
    case 'thisWeek':
      return subDate.isSame(moment(), 'week');
    case 'thisMonth':
      return subDate.isSame(moment(), 'month');
    default:
      return true;
  }
  }
  CreateForm() {
    this.CharityFilterForm = this.fb.group({
      date: [null],
      status:[null],
      accountingPeriod:[null]
    });
  }
  applyCharityFilter() {
    debugger
    this.charitydataSource = new MatTableDataSource(this.charitySubmissionsfromapi);
    const filteredSubmissions = this.charitydataSource.data.filter(submission => {
      return (!this.CharityFilterForm.get('status')?.value || submission.status?.toLowerCase() === this.CharityFilterForm.get('status')?.value?.toLowerCase()) &&
        (!this.CharityFilterForm.get('accountingPeriod')?.value || submission.accountingPeriod === this.CharityFilterForm.get('accountingPeriod')?.value) &&
        this.matchDate(submission.date, this.CharityFilterForm.get('date')?.value);
    });
    this.charitydataSource = new MatTableDataSource(filteredSubmissions);
    this.charitydataSource.filterPredicate = (data: any, filter: string): boolean => {
      const formattedFilter = filter.trim().toLowerCase();

      return Object.values(data).some((value: any) => {
        if (value == null) return false;
        return value.toString().toLowerCase().startsWith(formattedFilter);
      });
    };

    // Attach paginator and sort after data binding
    setTimeout(() => {
      this.charitydataSource.paginator = this.paginator2;
      this.charitydataSource.sort = this.sort2;
      this.paginator.length = this.charitydataSource.data.length;
    });
  }
  clearCharityfilter() {
    this.CreateForm();
    this.showCharitySubmission(this.Submissionsapiservice.currentcharityid)
  }
  xmldata(subid: any) {
    this.Submissionsapiservice.getXmldata(subid).subscribe((data: any) => {
      debugger
      this.xmlData = data.xmldata
    })
  }

 
  openXmlDialog(id: any): void {
    this.Submissionsapiservice.getXmldata(id).subscribe({
      next: (data: any) => {
        debugger

        this.xmlData = vkbeautify.xml(data.xmlResponse)
        this.xmlDataRequest = vkbeautify.xml(data.xmlRequest);
        this.charityName = data.charityName;
        debugger
        this.dialog.open(this.xmlViewerTemplate, {
          width: '60vw',
          maxWidth:'960px',
          height:'auto',
          disableClose: true,
          position: { top: '50px' },
          data: { xmlData: this.xmlDataRequest } // optional, if you want to pass via dialog data
        });
      },
      error: (err) => {
        console.error('Error fetching XML data:', err);
        // optionally show a snackbar or alert
      }
    });
  }
  downloadZip(id?: any, isView: any = false) {
    var filename = moment().format('YYYYMMDDHHmmss') + '_' + this.charityName+ '.zip'
    if (isView) {
      const zip = new JSZip();
      const ts = moment().format('YYYYMMDDHHmmss');

      zip.file(`${ts}_submitresponse.xml`, this.xmlData);
      zip.file(`${ts}_submitrequest.xml`, this.xmlDataRequest);

      zip.generateAsync({ type: 'blob', compression: 'DEFLATE' })
        .then((content) => {
          const zipName = filename
          saveAs(content, zipName);
        });
    }
    else {
      this.Submissionsapiservice.getXmldata(id).subscribe({
        next: (data: any) => {
          debugger
          this.xmlData = vkbeautify.xml(data.xmlResponse)
          this.xmlDataRequest = vkbeautify.xml(data.xmlRequest);
          this.charityName = data.charityName;
          debugger
          var filename = moment().format('YYYYMMDDHHmmss') + '_' + this.charityName + '.zip'

          const zip = new JSZip();
          const ts = moment().format('YYYYMMDDHHmmss');

          zip.file(`${ts}_submitresponse.xml`, this.xmlData);
          zip.file(`${ts}_submitrequest.xml`, this.xmlDataRequest);

          zip.generateAsync({ type: 'blob', compression: 'DEFLATE' })
            .then((content) => {
              const zipName = filename
              saveAs(content, zipName);
            });
        },
        error: (err) => {
          console.error('Error fetching XML data:', err);
          // optionally show a snackbar or alert
        }
      });
    }
   
  }
  fbiDownload(id: any) {
    this.loadspinner = true;

    this.Submissionsapiservice.FBIReceipt(id).subscribe(
      (data: any) => {
        // Convert base64 string to byte array
        const byteCharacters = atob(data.toString());
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Create a blob and a download link
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = moment().format('YYYYMMDDHHmmss') + '_' + localStorage.getItem('charity_Name') + ".pdf";
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        this.loadspinner = false;
      },
      (error) => {
        console.error('Error downloading FBI Receipt:', error);
        this.loadspinner = false;
      }
    );
  }

  fbiReceiptDownload(modal: any, id: any) {
    this.loadspinner=true
    this.Submissionsapiservice.FBIReceipt(id).subscribe((data: any) => {
      debugger
      this.loadspinner = false
      const byteCharacters = atob(data.toString());
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.pdfFile = URL.createObjectURL(blob);

      var Downloadreportname = moment().format('YYYYMMDDHHmmss') + '_' + localStorage.getItem('charity_Name') + ".pdf";
      this.dialog.open(modal, {
        width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
      });
      setTimeout(() => {
        if (this.pdfViewerAutoLoad) {
          this.pdfViewerAutoLoad.pdfSrc = this.pdfFile;
          this.pdfViewerAutoLoad.downloadFileName = Downloadreportname;
          this.pdfViewerAutoLoad.page = 1;
          this.pdfViewerAutoLoad.refresh();
          this.loadspinner=false
        }
      }, 1000)
    })
  }
  showCharitySubmission(charityid: any) {
    debugger
    this.CreateForm();
    this.filterblock=false
    this.loadspinner=true
    this.Submissionsapiservice.currentcharityid=charityid
    this.Submissionsapiservice.getCharitySubmissions(charityid).subscribe({

      next: (data: any[]) => {
        const submissions = data.map((item: any) => ({
          submissionId: item.submissionId,
          date: item.fbiStartTimeStamp,
          accountingPeriod: `${this.formatDate(item.current_AP_Start_Date)} - ${this.formatDate(item.current_AP_End_Date)}`,
          charityName: item.charityName,
          charityId: item.charityId,
          submissionType: item.account_Type,
          reference: item.submissionNumber,
          transactionNumber: item.transactionID || 'N/A',
          status: item.companyHouseSubmissionStatus || 'Pending'
        })).reverse();
        const seen = new Set<string>();
        const seen1 = new Set<string>();
        this.uniqueStatusSet  = submissions.filter(item => {
          const statusLower = item.status.toLowerCase();
          if (seen.has(statusLower)) {
            return false;
          }
          seen.add(statusLower);
          return true;
        }).map(item => item.status);

        this.charitySubmissions = submissions.filter(item => {
          const statusLower = item.accountingPeriod.toLowerCase();
          if (seen1.has(statusLower)) {
            return false;
          }
          seen1.add(statusLower);
          return true;
        }).map(item => item.accountingPeriod);
        debugger
        this.charitySubmissionsfromapi = submissions
        this.charitydataSource = new MatTableDataSource(submissions);
        this.charitydataSource.filterPredicate = (data: any, filter: string): boolean => {
          const formattedFilter = filter.trim().toLowerCase();

          return Object.values(data).some((value: any) => {
            if (value == null) return false;
            return value.toString().toLowerCase().startsWith(formattedFilter);
          });
        };

        // Attach paginator and sort after data binding
        setTimeout(() => {
          if (this.paginator2 && this.charitydataSource) {
            this.charitydataSource.paginator = this.paginator2;
            this.charitydataSource.sort = this.sort2;


            this.paginator2.pageSize = 10;

            this.paginator2.length = this.charitydataSource.data.length;


            this.paginator2._changePageSize(this.paginator2.pageSize);
          }
        });

        this.loadspinner = false;
      },
      error: (err) => {
        console.error('Error fetching submission history:', err);
        this.loadspinner = false;
      }
    });
      this.submissionHistoryGrid = false;
      this.submissionStatus = true;
    }

  backTohistory() {
    this.submissionHistoryGrid = true;
    this.submissionStatus = false;
    this.CreateForm()
    this.getCharities()
    this.getsubmissionhistory();
  }
 errorList:any=[]
  openErrorLog(template: any,subid:any) {
    debugger
    this.Submissionsapiservice.getError(subid).subscribe((data: any) => {
      if (data != null) {
        this.submissionId = subid
        this.errorList=data
      }
    })
    this.dialog.open(template, { width: '80%', disableClose: true, position: { top: '50px' }});
  }
  errorDownload(id: any) {
    debugger
    this.loadspinner = true;

    this.Submissionsapiservice.errorReport(id).subscribe(
      (data: any) => {
        // Convert base64 string to byte array
        const byteCharacters = atob(data.toString());
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Create a blob and a download link
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'ErrorLog.pdf';
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        this.loadspinner = false;
      },
      (error) => {
        console.error('Error downloading ErrorLog:', error);
        this.loadspinner = false;
      }
    );
  }

  displayedColumns: string[] = ['Date', 'CharityName', 'Accounting Period', 'SubmissionType', 'Reference', 'TransactionNumber', 'Status'];
  submissions: any[] = [
    { type: 'data', date: '28-10-2025', CharityName: 'Hope Foundation', SubmissionType: 'Charity Commission', Reference: 'CH-2024-001234', TransactionNumber: '012345', Status: '' },
    { type: 'data', date: '28-10-2025', CharityName: 'Hope Foundation', SubmissionType: 'Charity Commission', Reference: 'CH-2024-001234', TransactionNumber: '012345', Status: '' },
    { type: 'data', date: '28-10-2025', CharityName: 'Hope Foundation', SubmissionType: 'Charity Commission', Reference: 'CH-2024-001234', TransactionNumber: '012345', Status: '' },
  ];

  displayedColumns2: string[] = ['Date', 'Accounting Period', 'Reference', 'TransactionNumber', 'Status', 'action'];
  submissions2: any[] = [
    { type: 'data', date: '28-10-2025', CharityName: 'Hope Foundation', SubmissionType: 'Charity Commission', Reference: 'CH-2024-001234', TransactionNumber: '012345', Status: '', action: ''  },
    { type: 'data', date: '28-10-2025', CharityName: 'Hope Foundation', SubmissionType: 'Charity Commission', Reference: 'CH-2024-001234', TransactionNumber: '012345', Status: '', action: ''  },
    { type: 'data', date: '28-10-2025', CharityName: 'Hope Foundation', SubmissionType: 'Charity Commission', Reference: 'CH-2024-001234', TransactionNumber: '012345', Status: '', action: ''  },
  ];

}
